package org.lennycodes.hldi.styles
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme
val PartnerCardStyle = CssStyle {
    base {
        Modifier

            .backgroundColor(HLDITheme.Colors.white)
            .borderRadius(12.px)
            .textAlign(TextAlign.Center)
            .transition(Transition.of(property = "all", duration = 0.3.s, timingFunction = TransitionTimingFunction.Ease))
    }

    hover {
        Modifier
            .styleModifier { property("transform", "translateY(-4px)") }
    }
}